
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { GridMetadata } from "@tylertech/tyler-api-types";

/**
 * EmployeeRetirementService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeeRetirementService<TEntity = unknown> {
    private readonly $apiService = inject(ApiService);
    
    GetAdditionalStateInfoMetadata(employeeId: string): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IEmployeeRetirementService/GetAdditionalStateInfoMetadata", employeeId);
    }
    GetRetirementMetadata(employeeId: string): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IEmployeeRetirementService/GetRetirementMetadata", employeeId);
    }
    GetRetirementPositionMetadata(employeeId: string): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IEmployeeRetirementService/GetRetirementPositionMetadata", employeeId);
    }
    ReturnEmployeeRetirementRecords(employeeId: string): Promise<TEntity> {
        return this.$apiService.sendAuth("IEmployeeRetirementService/ReturnEmployeeRetirementRecords", employeeId);
    }
}
